import React from 'react';

const DEFAULT_WIDTHS = [320, 640, 1024];

function getBase(src) {
  const m = src.match(/(img-[a-f0-9]+)-\d+\.(webp|avif|jpe?g)$/i);
  if (m) return m[1];
  // fallback: try to remove trailing -640.webp etc
  const m2 = src.match(/(images\/optimized\/[a-z0-9\-]+)-\d+\.(webp|avif|jpe?g)$/i);
  if (m2) return m2[1].split('/').pop();
  return null;
}

export default function ResponsiveImage({ src, alt = '', className = '', sizes, loading = 'lazy', priority = false, decoding = 'async' }) {
  const base = getBase(src);
  const useSizes = sizes || '(max-width: 640px) 100vw, 33vw';


  if (!base) {
    // fallback to simple img
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        loading={priority ? 'eager' : loading}
        decoding={decoding}
        {...(priority ? { fetchPriority: 'high' } : {})}
      />
    );
  }

  const avifSrcSet = DEFAULT_WIDTHS.map((w) => `/images/optimized/${base}-${w}.avif ${w}w`).join(', ');
  const webpSrcSet = DEFAULT_WIDTHS.map((w) => `/images/optimized/${base}-${w}.webp ${w}w`).join(', ');
  const jpegSrcSet = DEFAULT_WIDTHS.map((w) => `/images/optimized/${base}-${w}.jpeg ${w}w`).join(', ');

  const fallback = `/images/optimized/${base}-640.jpeg`;

  return (
    <picture>
      <source type="image/avif" srcSet={avifSrcSet} sizes={useSizes} />
      <source type="image/webp" srcSet={webpSrcSet} sizes={useSizes} />
      <img
        src={fallback}
        srcSet={jpegSrcSet}
        sizes={useSizes}
        alt={alt}
        className={className}
        loading={priority ? 'eager' : loading}
        decoding={decoding}
        {...(priority ? { fetchPriority: 'high' } : {})}
      />
    </picture>
  );
}
